import { Component, Inject, OnInit, Provider } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ChangeDetectorRef } from '@angular/core';
import Swal from 'sweetalert2';
import { ProvidersService } from '../services/providers.service';

@Component({
  selector: 'app-provider-update-modal',
  templateUrl: './provider-update-modal.component.html',
  styleUrls: ['./provider-update-modal.component.css']
})
export class ProviderUpdateModalComponent implements OnInit {

  selectedRole: string = '';
  providerForm: FormGroup;


  public isLoading: boolean = false;

  constructor(
    private changeDetectorRef: ChangeDetectorRef,
    public dialogRef: MatDialogRef<ProviderUpdateModalComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private providersService: ProvidersService,
    private fb: FormBuilder,

  ) {
    this.providerForm = this.fb.group({
      role: [data.selectedRole || '', Validators.required]
    });
  }

  ngOnInit(): void {
    this.providerForm = this.fb.group({
      type: ['', Validators.required],
      status: ['', Validators.required]
    });
  }

  updateProvider(): void {
    const providerId = this.data.provider.id;
    const newFields = {
      type: this.providerForm.get('type')!.value,
      status: this.providerForm.get('status')!.value
    };

    this.isLoading = true;
    this.providersService.updateProvider(providerId, newFields).subscribe(
      () => {
        this.isLoading = false;

        Swal.fire({
          text: 'Cambio realizado exitosamente',
          icon: 'success',
          confirmButtonText: 'OK',
          confirmButtonColor: '#4caf50'
        }).then((res) => {
          if (res.isConfirmed) {
            this.providersService.rolEmitter.emit('refresh')

          }
        })
        this.changeDetectorRef.detectChanges();

        this.dialogRef.close();
      },
      (error) => {
        this.isLoading = false;
        Swal.fire({
          text: 'Error al realizar el cambio. Por favor, inténtalo de nuevo.',
          icon: 'error',
          confirmButtonText: 'OK',
          confirmButtonColor: '#d33'
        });
      }
    );
  }
  assingState(state: any) {
    this.selectedRole = state.target.value
  }
  assingType(type: any) {
    this.selectedRole = type.target.value
  }

  closeModal(): void {
    this.dialogRef.close();
  }


}
